/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'project-contributors-picker.done': '完成',
  'project-contributors-picker.go-back-label': '返回',
  'project-contributors-picker.header': '選擇專案上的成員',
  'project-contributors-picker.your-teams-secondary-text':
    '{membersCount, plural, other {{membersCount,number} 位成員}}',
  'project-contributors-picker.your-teams-secondary-text-focused':
    '{membersCount, plural, other {從 {membersCount,number} 位成員中選取}}',
  'project-contributors-picker.your-teams-title': '您的團隊',
  'project-fields.common.generic-error.description': '請檢查您的網際網路連線，然後再試一次。',
  'project-fields.common.generic-error.title': '發生錯誤',
  'project-fields.link-item.delete-label': '刪除',
  'project-fields.link-item.edit-label': '編輯',
  'project-fields.project-contributes-to.add-goal-title': '新增目標',
  'project-fields.project-contributes-to.empty-title': '沒有目標',
  'project-fields.project-contributes-to.title': '促成',
  'project-fields.project-contributors.add-contributors-title': '新增參與者',
  'project-fields.project-contributors.empty-title': '沒有參與者',
  'project-fields.project-contributors.remove-contributor': '移除參與者',
  'project-fields.project-contributors.remove-contributor-error-message': '無法移除參與者',
  'project-fields.project-contributors.remove-team': '移除團隊',
  'project-fields.project-contributors.show-more': '顯示較多',
  'project-fields.project-contributors.title': '參與者',
  'project-fields.project-contributors.view-profile': '檢視設定檔',
  'project-fields.project-contributors.view-profile-team': '檢視設定檔',
  'project-fields.project-focus-areas.title': '焦點區域',
  'project-fields.project-followers.add-followers-title': '新增追蹤者',
  'project-fields.project-followers.empty-title': '沒有追蹤者',
  'project-fields.project-followers.title': '追蹤者',
  'project-fields.project-jira-work-picker.create-work-item-button': '建立工作項目',
  'project-fields.project-jira-work-picker.recent-items-empty-image-alt': '近期工作項目空白狀態插圖',
  'project-fields.project-jira-work-picker.recents-empty-description': '您最近檢視的工作項目將在您開始時顯示在這裡。',
  'project-fields.project-jira-work-picker.recents-empty-title': '開始使用 Jira',
  'project-fields.project-jira-work-picker.search-placeholder': '搜尋 Jira 或貼上連結',
  'project-fields.project-jira-work-picker.title': '近期的工作項目',
  'project-fields.project-link-picker.aria-label': '最近檢視的連結',
  'project-fields.project-link-picker.invalid-link-input.error': '請檢查您的連結是否為有效的 URL。',
  'project-fields.project-link-picker.link-input.clear-label': '清除連結',
  'project-fields.project-link-picker.link-input.placeholder': '貼上連結或搜尋最近檢視的項目',
  'project-fields.project-link-picker.text-input.clear-label': '清除文字',
  'project-fields.project-link-picker.text-input.placeholder': '要顯示的文字 (選用)',
  'project-fields.project-links.add-links-title': '新增連結',
  'project-fields.project-links.add-links-tooltip': '新增文件、設計等連結',
  'project-fields.project-links.delete-link-button': '刪除連結',
  'project-fields.project-links.edit-link-button': '編輯連結',
  'project-fields.project-links.empty-title': '沒有連結',
  'project-fields.project-links.title': '連結',
  'project-fields.project-owner.title': '負責人',
  'project-fields.project-start-date.add-start-date-title': '新增開始日期',
  'project-fields.project-start-date.cancel-button': '儲存',
  'project-fields.project-start-date.creation-date': '此專案建立於 {creationDate}',
  'project-fields.project-start-date.edit-start-date-label': '編輯專案開始日期',
  'project-fields.project-start-date.empty-title': '沒有開始日期',
  'project-fields.project-start-date.enter-start-date-title': '輸入開始日期',
  'project-fields.project-start-date.open-calendar-label': '開啟行事曆',
  'project-fields.project-start-date.read-only': '只有具有編輯權限的參與者可以變更開始日期。',
  'project-fields.project-start-date.title': '開始日期',
  'project-fields.project-state.archived': '已封存',
  'project-fields.project-state.at-risk': '存在風險',
  'project-fields.project-state.cancelled': '已取消',
  'project-fields.project-state.completed': '已完成 🎉',
  'project-fields.project-state.off-track': '偏離正軌',
  'project-fields.project-state.on-track': '進度良好',
  'project-fields.project-state.paused': '已暫停',
  'project-fields.project-state.pending': '擱置中',
  'project-fields.project-status-picker.project-status-picker-more-button': '更多狀態',
  'project-fields.project-status.title': '狀態',
  'project-fields.project-tags.add-tags-title': '新增標記',
  'project-fields.project-tags.empty-title': '沒有主題',
  'project-fields.project-tags.title': '標記',
  'project-fields.project-target-date.picker-placeholder': '擱置中',
  'project-fields.project-target-date.title': '目標日期',
  'project-fields.project-work-items.show-all-non-final': '顯示全部',
  'project-fields.project-work-items.show-less-non-final': '顯示較少',
  'project-fields.project-work-tracked-picker.cancel-button': '儲存',
  'project-fields.project-work-tracked-picker.fallback-description': '針對您追蹤此專案工作的位置新增連結',
  'project-fields.project-work-tracked-picker.fallback-invalid-url': '請輸入有效的 URL',
  'project-fields.project-work-tracked-picker.no-recently-viewed-header': '搜尋 Jira 工作項目',
  'project-fields.project-work-tracked-picker.no-recently-viewed-result': '搜尋您追蹤此專案工作的位置，或新增連結。',
  'project-fields.project-work-tracked-picker.no-search-result':
    '請重新輸入 Jira 工作項目索引鍵或 URL，或使用其他詞彙進行搜尋。',
  'project-fields.project-work-tracked-picker.no-search-results-header': '我們找不到符合項目',
  'project-fields.project-work-tracked-picker.recently-viewed-title': '最近檢視的項目',
  'project-fields.project-work-tracked-picker.results-title': '結果',
  'project-fields.project-work-tracked-picker.search-placeholder': '搜尋 Jira 或新增連結',
  'project-fields.project-work-tracked-picker.sync-form-description':
    '將此專案與選取的 Jira 工作項目連結，並自動將詳細資料保持同步。',
  'project-fields.project-work-tracked-picker.sync-form-warning':
    '請注意，所有可以看到此 Jira 工作項目的人，都會看到您的專案詳細資料。',
  'project-fields.project-work-tracked-picker.sync-with-jira-button': '與 Jira 同步',
  'project-fields.project-work-tracked-picker.sync-with-jira-cancel-button': '取消',
  'project-fields.project-work-tracked-picker.sync-with-jira-connect-button': '連接',
  'project-fields.project-work-tracked-picker.sync-with-jira-detail-selection': '選取您將來要用於此工作的詳細資料：',
  'project-fields.project-work-tracked-picker.sync-with-jira-header': '將此專案與 Jira 同步',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing': '標籤同步',
  'project-fields.project-work-tracked-picker.sync-with-jira-label-syncing-description':
    '將 Jira 中的標籤與專案上的主題同步',
  'project-fields.project-work-tracked-picker.sync-with-jira-project-name': '專案名稱',
  'project-fields.project-work-tracked-picker.sync-with-jira-start-date': '開始日期',
  'project-fields.project-work-tracked-picker.sync-with-jira-target-date': '目標日期',
  'project-fields.project-work-tracked-picker.sync-with-jira-via-project': '{projectName} {viaProject}',
  'project-fields.project-work-tracked-picker.text-placeholder': '工作追蹤連結',
  'project-fields.project-work-tracked-picker.work-tracked-picker-content':
    '搜尋 Jira 工作項目，或者針對您追蹤此專案工作的位置新增連結。',
  'project-fields.project-work-tracked-picker.work-tracked-picker-title': '工作是在何處追蹤？',
  'project-fields.project-work-tracked.add-work-tracked-title': '新增 Jira 工作項目',
  'project-fields.project-work-tracked.empty-title': '沒有 Jira 工作項目',
  'project-fields.project-work-tracked.linked-with-jira-label': '已與 Jira 連結',
  'project-fields.project-work-tracked.sync-now-label': '立即同步',
  'project-fields.project-work-tracked.synced-with-jira-label': '已與 Jira 同步',
  'project-fields.project-work-tracked.title': '已追蹤工作',
  'project-fields.related-project-picker.add-button-label': '新增',
  'project-fields.related-project-picker.cancel-button-label': '取消',
  'project-fields.related-project-picker.depended-by-option-label': '哪個專案取決於此專案',
  'project-fields.related-project-picker.depends-on-option-label': '專案取決於',
  'project-fields.related-project-picker.empty-state-description': '尋找相關專案，以連結到此專案。',
  'project-fields.related-project-picker.empty-state-title': '搜尋專案',
  'project-fields.related-project-picker.project-relationship-type-label': '選取專案關係類型',
  'project-fields.related-project-picker.project-search-placeholder': '搜尋專案',
  'project-fields.related-project-picker.related-option-label': '專案相關',
  'project-fields.related-project-picker.related-project-list-label': '相關專案',
  'project-fields.related-projects.add-related-title': '新增相關專案',
  'project-fields.related-projects.add-related-tooltip': '新增相依或相關專案',
  'project-fields.related-projects.dependent-by-projects-heading': '哪個專案取決於此專案',
  'project-fields.related-projects.dependent-on-projects-heading': '取決於',
  'project-fields.related-projects.empty-title': '沒有相關專案',
  'project-fields.related-projects.related-projects-heading': '相關',
  'project-fields.related-projects.title': '相關',
  'project-fields.use-project-flags.generic-error-description': '發生錯誤，請在幾分鐘後再試一次。',
  'project-fields.use-project-flags.generic-error-title': '發生錯誤',
  'project-fields.use-project-flags.project-links-add-failure-title': '無法新增連結',
  'project-fields.use-project-flags.project-links-delete-failure-title': '無法移除連結',
  'project-fields.use-project-flags.project-links-edit-failure-title': '無法編輯連結',
  'project-fields.use-project-flags.project-owner-change-error-header': '無法變更專案負責人',
  'project-fields.use-project-flags.project-start-date-change-error-header': '我們無法更新專案的開始日期',
  'project-fields.use-project-flags.project-tags-add-failure-title': '無法新增主題',
  'project-fields.use-project-flags.project-tags-create-failure-title': '無法建立主題',
  'project-fields.use-project-flags.project-tags-create-limit-failure-description':
    '您輸入的主題名稱太長。請輸入 255 個字元以下的主題名稱。',
  'project-fields.use-project-flags.project-tags-create-limit-failure-title': '無法建立主題',
  'project-fields.use-project-flags.project-tags-remove-failure-title': '無法移除主題',
  'project-fields.use-project-flags.project-team-remove-failure-description': '移除團隊時發生錯誤，請再試一次',
  'project-fields.use-project-flags.related-project-remove-failure-title': '無法移除相關專案',
};
